// ============================================================================
// BOOK · constants — the 2026 printed book's grid and the rule wording
// ============================================================================
// Ported from David's approved prototype
// (docs/collection-book/2026-10-22-collection-book-prototype-v2.html): the page
// is A4 in points and every position below is the 2026 InDesign master, so the
// screen draws a page at 1 px = 1 pt and scales the whole page to fit.
// ============================================================================

export const PW = 595.276;                       // A4 width, pt
export const PH = 841.89;                        // A4 height, pt
export const SPINE = 26;                         // the binder spine between two pages, px
export const COL_X = [48.4, 310.0];              // the two cell columns
export const ROW_Y = [48.6, 300.8, 553.0];       // the three cell rows
export const TH_X = [0, 60.5, 121.0, 181.3];     // colour thumbnails inside a cell
export const TH_Y = [110.7, 171.2];
export const CELL_MAIN = { w: 237.6, h: 96 };    // the big side photo of a cell
export const CELL_THUMB = 56.3;                  // one colour thumbnail

export const PER_PAGE = 6;                       // always 6 models per page (2 x 3)
export const FIRST_PAGE = 2;                     // page 1 = the contents, the models start right after it on page 2 (David 30.10: the free pages 2-3 are gone)
export const FAM_ORDER = ['Acetate', 'Metal'];   // David 21.10: Acetate first inside a section
export const RN_ORDER = ['R', 'N'];              // repeats before new inside a family

// David 24.10: a front cover before page 1, unnumbered, not counted in the pages. David 30.10: it is also
// the first page of the PDF (print model opts.cover); the InDesign file still has no cover. It is page "0" of the spreads: spread 0 = the cover
// alone on the right (a closed book), spread 1 = the inside of the cover + page 1 (the contents).
export const COVER = 0;
export const OPEN_SPREAD = 1;                    // opening the book lands on the contents

// David 24.10: the Optic book, the same design on the Order Book's optic lines (book 'optic').
// The order of the keys is the order of the header switch.
export const BOOKS = {
  'sun-ss2027': { key: 'sun-ss2027', line: 'sun', collection: 'SS2027', label: 'Sun · SS2027' },
  'optic-ss2027': { key: 'optic-ss2027', line: 'optic', collection: 'SS2027', label: 'Optic · SS2027' },
};
/** The book that opens when nothing names one (Home's card, the store's start). */
export const DEFAULT_BOOK = 'sun-ss2027';

/** The line as the printed book names it (the 2026 binder: "Sunglasses Collection"; David 24.10: "Optic Collection"). */
export const LINE_NAME = { sun: 'Sunglasses Collection', optic: 'Optic Collection' };

/** { line, year } from a book's meta: the year from its own collection (SS2027 → 2027), never fixed here. */
export function seasonOf(meta) {
  const m = /(\d{4})/.exec(String((meta && meta.collection) || ''));
  return { line: (meta && LINE_NAME[meta.line]) || 'Collection', year: m ? m[1] : '' };
}

/** The sticker images and the four default rules (the database seeds the same four). */
export const STICKERS = {
  'after-cny': 'after CNY',
  'in-between': 'in between',
  spring: 'Spring',
  'autumn-collection': 'Autumn collection',
};

/** A sub-shape and the section parent the system files it under (the data check). */
export const HOME_PARENT = {
  Geo: 'Geo', Frameless: 'Frameless', Rectangle: 'Rectangle', Square: 'Square', Round: 'Round', Oval: 'Oval',
  'New Fem': 'New Fem', Cat: 'Cat', Fem: 'Fem', Wrap: 'Fem', Mask: 'Fem',
  'D.bridge': 'D.bridge', Men: 'Men', Pilot: 'Pilot', Sport: 'Men', 'Sport Mask': 'Trendy',
  "70's": 'Trendy', Racer: 'Trendy',
};

/** Why a page is blank — the short form (filmstrip, book check). */
export const REASON_SHORT = {
  align: 'group starts on a left page',
  odd: 'odd block — last page moves right',
  single: 'single page sits on the right',
  end: 'section ends — next starts left',
};

/** Why a page is blank — the sentence on the blank page, as plain parts ({ b } = bold). */
export function reasonParts(page) {
  const ref = page.ref && page.ref.label;
  switch (page.reason) {
    case 'align': return [{ b: ref }, ' has to start on a left page, so its pages open together.'];
    case 'odd': return [{ b: ref }, ' has an odd number of pages. Its last page moves right, so ',
      page.after ? { b: page.after.group.label } : 'the next group', ' opens on a fresh spread.'];
    case 'single': return [{ b: ref }, ' fills one page. It sits on the right, alone on its spread.'];
    case 'end': return [{ b: page.sec.label }, ' ends here. The next section starts on a left page.'];
    default: return [];
  }
}
